import { useEffect, useState } from 'react'

interface WaveformIndicatorProps {
  level: number // 0-1 audio level
  isActive: boolean
}

export function WaveformIndicator({ level, isActive }: WaveformIndicatorProps) {
  const [bars, setBars] = useState<number[]>([0, 0, 0, 0, 0])

  useEffect(() => {
    if (isActive) {
      // Animate bars based on audio level
      setBars([
        level * 0.8 + Math.random() * 0.2,
        level * 1.0 + Math.random() * 0.3,
        level * 1.2 + Math.random() * 0.2,
        level * 0.9 + Math.random() * 0.3,
        level * 0.7 + Math.random() * 0.2,
      ])
    } else {
      setBars([0, 0, 0, 0, 0])
    }
  }, [level, isActive])

  return (
    <div className="flex items-center justify-center gap-1 h-12">
      {bars.map((height, i) => (
        <div
          key={i}
          className="w-2 bg-brand-500 rounded-full transition-all duration-100"
          style={{
            height: `${Math.max(4, height * 48)}px`,
            opacity: isActive ? 0.8 : 0.3,
          }}
        />
      ))}
    </div>
  )
}
